import toTitleCase from "./toTitleCase";

const nameOverrides = {};

export default function formatName(name) {
    return nameOverrides[name] || toTitleCase(name);
}
